import { Alert, Box, Paper, Stack, Typography } from '@mui/material';
import { BulkRetryPreviewResponse } from '../../../interfaces/bulkReprocess';

interface Props {
  preview: BulkRetryPreviewResponse;
}

export const BulkReprocessPreviewTable: React.FC<Props> = ({ preview }) => {
  const overCap = preview.count > preview.maxBatchSize;

  return (
    <Paper variant='outlined' sx={{ p: 2, mt: 2 }}>
      <Stack direction='row' spacing={4} alignItems='center' sx={{ mb: 2 }}>
        <Typography variant='subtitle1'>
          Matched documents: <strong>{preview.count}</strong>
        </Typography>
        <Typography variant='caption' color='text.secondary'>
          Max per batch: {preview.maxBatchSize}
        </Typography>
      </Stack>

      {overCap && (
        <Alert severity='warning' sx={{ mb: 2 }}>
          Match exceeds the {preview.maxBatchSize}-doc batch cap. Narrow the filter (smaller date
          range, fewer types, or single clinic) before confirming.
        </Alert>
      )}

      {preview.count === 0 ? (
        <Typography variant='body2' color='text.secondary'>
          No documents matched the supplied filter.
        </Typography>
      ) : (
        <Box>
          <Typography variant='caption' color='text.secondary'>
            Showing first {Math.min(preview.sampleIds.length, 50)} of {preview.count} IDs:
          </Typography>
          <Box
            sx={{
              mt: 1,
              fontFamily: 'monospace',
              fontSize: '12px',
              maxHeight: 240,
              overflowY: 'auto',
              p: 1,
              backgroundColor: 'rgba(0,0,0,0.03)',
              borderRadius: 1,
            }}>
            {preview.sampleIds.join(', ')}
            {preview.count > preview.sampleIds.length && (
              <Typography variant='caption' color='text.secondary' sx={{ display: 'block', mt: 1 }}>
                …{preview.count - preview.sampleIds.length} more
              </Typography>
            )}
          </Box>
        </Box>
      )}
    </Paper>
  );
};
